import { Form } from '@unform/web';
import styled from 'styled-components';

export const Container = styled.div`
  .product-rating-reviews-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 2rem;
    margin-bottom: 2rem;
    color: var(--gray_bold);

    > span {
      text-transform: uppercase;
      font-weight: 700;
      color: var(--gray_intermediary);
    }
  }

  .product-rating-group {
    font-weight: 700;
    margin-bottom: -1.4rem;
  }

  .rating-product {
    font-size: 6rem;
  }

  .rating-max {
    font-size: 2.6rem;
  }

  > span {
    text-transform: uppercase;
    color: var(--gray_intermediary);
    font-weight: 700;
    font-size: 1.4rem;
  }

  .rating {
    margin: 0.6rem 0;

    .icon {
      width: 1.3rem;
      height: 1.3rem;

      &.regHalfStar-icon {
        width: 1.4rem;
        height: 1.4rem;
      }
    }
  }

  .product-reviews {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 6rem;

    .product-reviews-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 2rem;

      span {
        font-size: 1.6rem;
        font-weight: 700;
      }

      .simple-select {
        width: 15rem;

        .react-select__control {
          height: 2.5rem;
          background-color: white;
          font-size: 0.9rem;
          font-weight: 400;
          color: #a5a5a5;
        }
      }
    }
  }

  .rating-list {
    display: flex;
    flex-direction: column;
  }

  .product-rating-without-reviews {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 20rem;
    gap: 1rem;
    font-size: 1.4rem;
    text-align: center;

    span {
      color: var(--gray_intermediary);
      font-weight: 700;
    }

    button {
      width: max-content;
      text-transform: none;
      padding: 0 0.8rem;
      font-size: 1.4rem;
      font-weight: 500;
    }

    button:hover {
      color: var(--white);
      background-color: var(--primary_color);
    }
  }

  @media (max-width: 1200px) {
    .product-rating-item {
      font-size: 1.3rem;
    }
  }

  @media (max-width: 1100px) {
    .product-rating-item {
      font-size: 1.1rem;
    }
  }

  @media (max-width: 768px) {
    .rating-product {
      font-size: 4rem;
    }

    .rating-max {
      font-size: 1.8rem;
    }

    .product-rating-group + span {
      margin-top: 1rem;
    }

    .product-rating-reviews-content > span,
    .product-rating-without-reviews,
    .product-rating-without-reviews button {
      font-size: 0.9rem;
    }

    .product-rating-reviews-content > .rating .stars img {
      width: 1rem;
    }

    .product-reviews .product-reviews-options span {
      font-size: 1.4rem;
    }

    .product-rating-item {
      font-size: 0.9rem;
      gap: 1.2rem;

      .rating .stars img {
        width: 0.8rem;
      }
    }
  }

  @media (max-width: 580px) {
    .product-reviews .product-reviews-options span {
      font-size: 1.2rem;
    }
  }

  @media (max-width: 520px) {
    .product-rating-item,
    .product-rating-without-reviews,
    .product-rating-without-reviews button {
      font-size: 0.8rem;
    }

    .product-rating-item .rating .stars img {
      width: 0.7rem;
    }

    .product-reviews .product-reviews-options span {
      font-size: 1rem;
    }
  }

  @media (max-width: 470px) {
    .product-rating-reviews-content {
      padding: 1rem;
    }
  }

  @media (max-width: 400px) {
    .product-reviews .product-reviews-options span {
      font-size: 0.8rem;
    }

    .product-rating-reviews-content > span,
    .product-rating-item,
    .product-rating-without-reviews span,
    .product-rating-without-reviews button {
      font-size: 0.7rem;
    }

    .product-rating-reviews-content > .rating .stars img {
      width: 0.8rem;
    }

    .product-rating-item .rating .stars img {
      width: 0.6rem;
    }
  }
`;
